import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const API = process.env.REACT_APP_BACKEND_URL;

const AuthCallback = () => {
  const navigate = useNavigate();
  const { applyGoogleSession } = useAuth();
  const hasProcessed = useRef(false);
  const [message, setMessage] = useState("Signing you in…");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      setMessage("Missing session — redirecting…");
      setTimeout(() => navigate("/members", { replace: true }), 800);
      return;
    }

    (async () => {
      try {
        const res = await fetch(`${API}/api/auth/session`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Session-ID": sessionId,
          },
          credentials: "include",
        });
        if (!res.ok) throw new Error("session exchange failed");
        const data = await res.json();
        await applyGoogleSession(data);
        // Clean the URL fragment before navigating
        window.history.replaceState(null, "", "/members");
        navigate("/members", { replace: true });
      } catch (e) {
        setMessage("Sign-in failed — please try again.");
        setTimeout(() => navigate("/members", { replace: true }), 1200);
      }
    })();
  }, [applyGoogleSession, navigate]);

  return (
    <div className="auth-callback">
      <div className="auth-callback-inner">
        <div className="auth-callback-spinner" aria-hidden="true" />
        <p>{message}</p>
      </div>
    </div>
  );
};

export default AuthCallback;
